import React from 'react';
import PropTypes from 'prop-types';
import Field from 'zignal-landscape/lib/Field';
import Label from 'zignal-landscape/lib/Label';
import ToggleSwitch from 'zignal-landscape/lib/ToggleSwitch';
import {
  ROLES_BY_VALUE, hasMinimumRole, discoverToggle, showFullAccountAccess, canEditAdditionalAccounts,
} from '../userFormRules';

const Toggle = ({ id, label, checked, disabled, onChange }) => (
  <Field>
    <Label htmlFor={id}>{label}</Label>
    <div data-cy={id}>
      <ToggleSwitch id={id} enabled={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />
    </div>
  </Field>
);
Toggle.propTypes = { id: PropTypes.string.isRequired, label: PropTypes.string.isRequired, checked: PropTypes.bool, disabled: PropTypes.bool, onChange: PropTypes.func.isRequired };

const FeatureToggles = ({ values, onChange, context }) => {
  const { screen, isNew, currentUser, loadedUser, accountDetectEnabled, accountNarrativesEnabled } = context;
  const editorIsAdmin = !!currentUser && currentUser.isAdmin === true;
  const editorIsInternalAdmin = !!currentUser && currentUser.isInternalAdmin === true;
  const targetRoles = (!isNew && loadedUser && loadedUser.roles) || ROLES_BY_VALUE[values.role] || [];
  const discover = discoverToggle({ roleValue: values.role, savedDiscoverEnabled: values.discoverEnabled });

  return (
    <div>
      {editorIsAdmin && (
        <Toggle
          id="user-form-detect-enabled" label="Detect Access" checked={values.detectEnabled === true}
          disabled={!accountDetectEnabled} onChange={(v) => onChange('detectEnabled', v)}
        />
      )}
      {editorIsAdmin && (
        <Toggle
          id="user-form-discover-enabled" label="Discover Access" checked={discover.checked}
          disabled={!discover.enabled} onChange={(v) => onChange('discoverEnabled', v)}
        />
      )}
      {hasMinimumRole(targetRoles, 'ROLE_CAMPAIGN_ADMIN') && (
        <Toggle
          id="user-form-narratives-enabled" label="Narratives Access" checked={values.narrativesEnabled === true}
          disabled={!accountNarrativesEnabled} onChange={(v) => onChange('narrativesEnabled', v)}
        />
      )}
      {editorIsInternalAdmin && screen !== 'mySettings' && (
        <Toggle
          id="user-form-is-automated" label="Automated (QA Only)" checked={values.isAutomated === true}
          onChange={(v) => onChange('isAutomated', v)}
        />
      )}
      {editorIsInternalAdmin && (
        <Toggle
          id="user-form-api-enabled" label="API Access" checked={values.apiEnabled === true}
          onChange={(v) => onChange('apiEnabled', v)}
        />
      )}
      {showFullAccountAccess({ currentUser, roleValue: values.role }) && (
        <Toggle
          id="user-form-full-account-access" label="Full Account Access" checked={values.fullAccountAccessEnabled === true}
          disabled={!canEditAdditionalAccounts(currentUser)} onChange={(v) => onChange('fullAccountAccessEnabled', v)}
        />
      )}
    </div>
  );
};

FeatureToggles.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  context: PropTypes.shape({
    screen: PropTypes.string.isRequired,
    isNew: PropTypes.bool.isRequired,
    currentUser: PropTypes.object.isRequired,
    loadedUser: PropTypes.object,
    accountDetectEnabled: PropTypes.bool,
    accountNarrativesEnabled: PropTypes.bool,
  }).isRequired,
};

export default FeatureToggles;
